'use strict';

class Popups {
    constructor() {
        this.popups = [];
        this.popupTriggers = [];
        this.activePopup = null;
    }

    init() {
        const self = this;

        this.popups = Array.prototype.slice.call(document.querySelectorAll('.tps-popup'));
        this.popupTriggers = Array.prototype.slice.call(document.querySelectorAll('.tps-popup-trigger'));

        this.popupTriggers.forEach(function(trigger) {
            const targetPopup = document.getElementById(trigger.dataset.popupTrigger);

            trigger.addEventListener('click', function(e) { self.onTriggerActivated.call(this, event, trigger, targetPopup, self); });
            if (trigger.id === 'buttonPhoneInfo') {
                trigger.addEventListener('mouseenter', function(e) { self.onTriggerActivated.call(this, event, trigger, targetPopup, self); });
                trigger.addEventListener('mouseleave', function(e) { self.onTriggerActivated.call(this, event, trigger, targetPopup, self); });
                targetPopup.addEventListener('mouseleave', function(e) { self.onTargetLeave.call(this, event, trigger, targetPopup, self); });
            }
        });

        this.onWindowClick();
    }

    onTriggerActivated(e, trigger, targetPopup, self) {
        if (e.target.classList.contains('has-tip')) return false;
        e.stopImmediatePropagation();
        if (targetPopup) {
            self.showPopup(targetPopup);
        }
    }

    onTargetLeave(e, trigger, targetPopup, self) {
        e.stopImmediatePropagation();
        if (targetPopup && !targetPopup.isClicked) {
            self.hidePopup(targetPopup);
        }
    }

    onWindowClick() {
        const self = this;
        window.addEventListener('click', function(e) {
            if (self.activePopup && !self.activePopup.contains(e.target)) {
                self.hideAllPopups();
            }
        });
    }

    showPopup(popup) {
        this.hideAllPopups();
        popup.classList.add('active');
        this.activePopup = popup;
    }

    hidePopup(popup) {
        popup.classList.remove('active');
        this.activePopup = null;
    }

    hideAllPopups() {
        this.popups.forEach(function(popup) {
            popup.classList.remove('active');
        });
        this.activePopup = null;
    }
}